import React from "react";

export function Logo({ size = 36, className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="FlexiVouch logo"
    >
      <defs>
        <linearGradient id="fv-grad" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stopColor="#0A2540" />
          <stop offset="100%" stopColor="#133D6B" />
        </linearGradient>
      </defs>
      <rect x="2" y="2" width="60" height="60" rx="16" fill="url(#fv-grad)" />
      {/* Voucher ticket */}
      <path
        d="M14 22h36a2 2 0 0 1 2 2v6a4 4 0 0 0 0 8v6a2 2 0 0 1-2 2H14a2 2 0 0 1-2-2v-6a4 4 0 0 0 0-8v-6a2 2 0 0 1 2-2z"
        fill="#FFFFFF"
        opacity="0.96"
      />
      {/* Teal slash mark */}
      <path d="M22 38l8-10 4 6 8-12" stroke="#00C4B4" strokeWidth="3.2" fill="none" strokeLinecap="round" strokeLinejoin="round" />
      {/* Dotted perforation */}
      <circle cx="39" cy="34" r="1.4" fill="#00C4B4" />
    </svg>
  );
}

export function LogoMark({ className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Logo size={32} />
      <span className="font-display font-bold text-[#0A2540] text-lg sm:text-xl tracking-tight">
        Flexi<span className="text-[#00C4B4]">Vouch</span>
      </span>
    </div>
  );
}
